import DIApi from '../di/_diApi';

class FrFunctionListAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'FrFunctionLists';
}

export default new FrFunctionListAPI();
